import type { Icon } from "iconsax-react";
import { Chart2, LinkCircle, MessageText1, Messages2 } from "iconsax-react";

import { InstagramAccountStatus } from "@/api/schemas/instagramAccountStatus";

// Connecting is parked behind the coming-soon page until the Meta app setup is unblocked.
export const INSTAGRAM_BOT_ENABLED = false;

export const INSTAGRAM_PROFILE_BASE_URL = "https://instagram.com/";

export const INSTAGRAM_FEATURES: { key: string; icon: Icon; titleKey: string; descriptionKey: string }[] =
  [
    {
      key: "autoReply",
      icon: MessageText1,
      titleKey: "features.autoReply.title",
      descriptionKey: "features.autoReply.description",
    },
    {
      key: "commentToDm",
      icon: Messages2,
      titleKey: "features.commentToDm.title",
      descriptionKey: "features.commentToDm.description",
    },
    {
      key: "orderLink",
      icon: LinkCircle,
      titleKey: "features.orderLink.title",
      descriptionKey: "features.orderLink.description",
    },
    {
      key: "insights",
      icon: Chart2,
      titleKey: "features.insights.title",
      descriptionKey: "features.insights.description",
    },
  ];

export const INSTAGRAM_CONNECT_STEP_KEYS = ["steps.login", "steps.approve", "steps.ready"];

export const INSTAGRAM_REQUIREMENT_KEYS = [
  "requirements.professional",
  "requirements.admin",
  "requirements.oneStore",
];

export const INSTAGRAM_STATUS_META: Record<
  InstagramAccountStatus,
  { labelKey: string; color: "success" | "warning" | "error" }
> = {
  [InstagramAccountStatus.active]: { labelKey: "account.connected", color: "success" },
  [InstagramAccountStatus.expired]: { labelKey: "account.expired", color: "warning" },
  [InstagramAccountStatus.revoked]: { labelKey: "account.revoked", color: "error" },
};

export const INSTAGRAM_CALLBACK_FAILURE_REASONS = [
  "already_connected",
  "link_expired",
  "unavailable",
  "instagram_error",
  "unknown",
] as const;

export type InstagramCallbackFailureReason = (typeof INSTAGRAM_CALLBACK_FAILURE_REASONS)[number];

export const INSTAGRAM_CALLBACK_STATUSES = ["success", "denied", "failed"] as const;

export type InstagramCallbackStatus = (typeof INSTAGRAM_CALLBACK_STATUSES)[number];
